import { useCallback, useEffect, useState } from 'react';
import { auditApi } from 'App';

export const usePreSignedUrl = (traceHandle?: string) => {
  const [preSignedUrl, setPreSignedUrl] = useState<string | null>(null);

  const getPreSignedUrl = useCallback(async () => {
    if (traceHandle) {
      const result = await auditApi.fetchTraceUrl(traceHandle);
      setPreSignedUrl(result);
    }
  }, [traceHandle]);

  useEffect(() => {
    getPreSignedUrl();
  }, [getPreSignedUrl]);

  return { preSignedUrl, refreshPreSignedUrl: getPreSignedUrl };
};
